var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "carousel", staticClass: "carousel" }, [
    _c(
      "div",
      { ref: "track", staticClass: "carousel-track" },
      _vm._l(_vm.images, function(image, index) {
        return _c(
          "div",
          { key: index, staticClass: "slide", attrs: { "data-index": index } },
          [
            _c(
              "a",
              {
                attrs: { href: image.destUrl, target: "_blank" },
                on: {
                  click: function($event) {
                    !image.destUrl && $event.preventDefault()
                  }
                }
              },
              [_c("img", { attrs: { src: image.content } })]
            )
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dots" },
      _vm._l(_vm.totalSlides, function(_, i) {
        return _vm.totalSlides > 0
          ? _c("span", {
              key: i,
              staticClass: "dot",
              class: { active: i === _vm.currentIndex },
              on: {
                click: function($event) {
                  _vm.goToSlide(i)
                }
              }
            })
          : _vm._e()
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2dedc691", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2dedc691","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider.vue
// module id = null
// module chunks = 